import { Suspense, lazy, useCallback, useState } from 'react'
const NVModal = lazy(() => import('./NVModal'))

const useNVModal = (ref) => {
  const [isOpen, setIsOpen] = useState(false)
  const openModal = useCallback(() => {
    setIsOpen(true)
  }, [])
  const closeModal = useCallback(() => {
    setIsOpen(false)
  }, [])

  const NVModalWrapper = useCallback(
    ({ ...props }) => {
      const handleClose = () => {
        setIsOpen(false)
        props.onClose && props.onClose(false)
      }
      return (
        isOpen && (
          <Suspense fallback={null}>
            <NVModal {...props} isOpen={isOpen} onClose={handleClose} />
          </Suspense>
        )
      )
    },
    [isOpen],
  )
  const response = {
    NVModal: NVModalWrapper,
    isModalOpen: isOpen,
    openModal,
    closeModal,
  }
  if (ref) ref.current = response
  return response
}

export { useNVModal as default, useNVModal }
